module.exports = __webpack_public_path__ + "img/circular-circle-radio.514515a7.png";